export const StateKey = 'ApplicationStates';
export const AppStateReducerInfo = {
    stateKey: StateKey,
    reducer: (state, action) => {
        let newState = {};
        const toMerge = {};
        switch (action.type) {
            case '@@EPI/INIT':
                newState = loadInitialState();
                break;
            case 'ApplicationStates/SetNavOpen':
                cpyAttr('navOpen', action, toMerge);
                newState = Object.assign(Object.assign({}, state), toMerge);
                storeState(newState);
                break;
            case 'ApplicationStates/SetGlossaryOpen':
                cpyAttr('glossaryOpen', action, toMerge);
                newState = Object.assign(Object.assign({}, state), toMerge);
                storeState(newState);
                break;
            case 'ApplicationStates/SetOnetrustchange':
                cpyAttr('onetrustchange', action, toMerge);
                newState = Object.assign(Object.assign({}, state), toMerge);
                storeState(newState);
                break;
        }
        return newState;
    }
};
function cpyAttr(key, from, to) {
    if (from[key] != undefined)
        to[key] = from[key];
}
function loadInitialState() {
    try {
        const localData = JSON.parse(localStorage.getItem(StateKey));
        const data = {
            navOpen: false,
            glossaryOpen: localData.glossaryOpen,
            onetrustchange: ''
        };
        return data;
    }
    catch (e) {
        // Ignored on purpose
    }
    return {};
}
function storeState(state) {
    try {
        localStorage.setItem(StateKey, JSON.stringify(state));
    }
    catch (e) {
        // Ignored on purpose
    }
}
export default AppStateReducerInfo;
